module.exports = __webpack_public_path__ + "img/31.d04218b5.svg";